import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = t((o, r) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: r,
    ...o,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3709",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M3.74 8.75h7.51c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H3.9c1.22-.99 2.23-2.46 2.23-4.5 0-.41-.34-.75-.75-.75s-.75.34-.75.75c0 3.48-3.9 4.52-4.06 4.56-.33.08-.56.38-.57.71-.01.34.21.64.53.73.04.01 4.15 1.28 4.15 4.49 0 .41.34.75.75.75s.75-.34.75-.75c.01-2.11-1.19-3.56-2.44-4.49"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M14.81 0H9.36a.749.749 0 1 0 0 1.5h5.14v13H9.36a.749.749 0 1 0 0 1.5h5.45c.66 0 1.19-.54 1.19-1.2V1.2c0-.66-.54-1.2-1.19-1.2"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3709)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyLogoutIcon";
export {
  i as AgencyLogoutIcon,
  i as default
};
//# sourceMappingURL=index.js.map
